<template>
    <div class="o-contact">
        <m-title title="Formularz kontaktowy" />

        <div class="l-row">
            <div class="l-row__column">
                <form
                    v-if="contactFormData && isContactFormReady"
                    @submit.prevent="onFormSubmit"
                >
                    <m-control
                        label="Imię"
                        name="name"
                        placeholder="Imię"
                        v-model="contactFormData.name"
                    />

                    <m-control
                        label="Nazwisko"
                        name="surname"
                        placeholder="Nazwisko"
                        v-model="contactFormData.surname"
                    />

                    <m-control
                        label="Nazwa firmy"
                        name="companyName"
                        placeholder="Nazwa firmy"
                        v-model="contactFormData.companyName"
                        required
                    />

                    <m-control
                        type="search"
                        label="Powiat"
                        placeholder="Powiat"
                        name="counties"
                        :value="contactFormData.counties"
                        :object="true"
                        :multiple="true"
                        @input="contactFormData.counties = $event"
                    />
                    <m-tags :value="contactFormData.counties" />

                    <m-control
                        label="Ilość hektarów"
                        name="area"
                        placeholder="hektary"
                        v-model="contactFormData.area"
                    />
                    <m-control
                        type="text"
                        id="phone"
                        name="phone"
                        label="Telefon"
                        placeholder="Telefon"
                        v-model="contactFormData.phone"
                    />
                    <m-control
                        type="textarea"
                        label="Wiadomość"
                        name="message"
                        placeholder="Wpisz treść"
                        v-model="contactFormData.message"
                    />

                    <div class="m-control">
                        <a-checkbox :checked.sync="contactFormData.agreement">
                            <span class="m-control__label">
                                Zgadzam się na przetwarzanie moich danych w celu
                                odpowiedzi na wysłane zapytanie.
                                <span class="requiredStar">*</span></span
                            >
                        </a-checkbox>
                    </div>

                    <div class="l-row">
                        <div class="l-row__column">
                            <a-button
                                @click="onSubmitClick"
                                submit
                                type="fullwidth"
                                :is-processing="emailPending"
                                :disabled="emailPending"
                            >
                                Wyślij
                            </a-button>
                            <div v-if="!formValid && submitBtnFired">
                                <div class="o-contact__formError">
                                    Formularz zawiera błędy
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import ACheckbox from '../components/global/ACheckbox.vue'
import { EmailStatuses } from '../store/contact.module'

export default {
    name: 'ContactForm',
    components: { ACheckbox },
    data() {
        return {
            isContactFormReady: false,
            submitBtnFired: false,
            emptyFormData: {
                name: '',
                surname: '',
                companyName: '',
                counties: [],
                area: '',
                message: '',
                phone: '',
                agreement: false
            },
            contactFormData: null
        }
    },
    async mounted() {
        if (!this.userProfile) {
            await this.$store.dispatch('fetchUserProfile')
        }

        if (this.userProfile) {
            this.emptyFormData.name = this.userProfile.first_name || ''
            this.emptyFormData.surname = this.userProfile.last_name || ''
            this.emptyFormData.phone = this.userProfile.phone || ''
            this.emptyFormData.counties = this.userProfile.counties || ''
        }

        this.fillFormWithInitialData()
        this.isContactFormReady = true
    },
    computed: {
        userProfile() {
            return this.$store.getters.userProfile
        },
        emailPending() {
            return (
                this.$store.getters['contact/getStatus'] ===
                EmailStatuses.PENDING
            )
        },
        formValid() {
            const { companyName, agreement } = this.contactFormData
            return !!companyName && !!agreement
        }
    },

    methods: {
        fillFormWithInitialData() {
            this.contactFormData = Object.assign(
                {},
                JSON.parse(JSON.stringify(this.emptyFormData))
            )
        },
        resetForm() {
            this.contactFormData = null
            this.submitBtnFired = false

            this.$nextTick(() => {
                this.fillFormWithInitialData()
            })
        },
        onSubmitClick() {
            this.submitBtnFired = true
            if (!this.contactFormData.companyName) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij nazwę firmy'
                })
                return
            }
            if (!this.contactFormData.agreement) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Zaznacz wymaganą zgodę'
                })
            }
        },
        onFormSubmit() {
            if (!this.formValid) return

            const counties = this.contactFormData.counties.map(e => e.id)
            const formData = Object.assign({}, this.contactFormData)
            formData.counties = { _ids: counties }

            this.$store
                .dispatch('contact/sendEmail', formData)
                .then(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Wiadomość została wysłana'
                    })
                    this.resetForm()
                })
                .catch(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
        }
    }
}
</script>
